import { notifications } from '~/app/notifications'
import AppImage from '@theme/components/atom/AppImage'
import HeadingLevel from '~/mixins/HeadingLevel'
import LoadingMixin from '~/mixins/LoadingMixin'
import contentSettings from '@site/content.settings'

export default {
  components: {
    AppImage,
  },
  mixins: [HeadingLevel, LoadingMixin],
  props: {
    gift: {
      type: Object,
      required: true,
    },
    quantity: {
      type: Number,
      default: 1,
    },
    scaled: Boolean,
    showMore: Boolean,
  },
  computed: {
    giftPrice() {
      const coeff = Math.pow(10, this.$store.state.currency.activeCurrency?.decimalPlaces || 0)
      return Math.ceil((contentSettings.giftPrice || 0) * coeff) / coeff
    },
    isSelectable() {
      return this.remainder <= 0 && !this.isPriceToLimited
    },
    isPriceToLimited() {
      return this.gift.price_to !== 0 && this.$store.state.cart.cartData.prices.totalWithTax > this.gift.price_to
    },
    isSelected() {
      return !!this.$store.state.cart.selectedGifts.find(g => g.id === this.gift.id)
    },
    priceFormatted() {
      return this.$currencyFormat(this.gift.product.prices.originalWithTax)
    },
    reachedMaxCountOfGifts() {
      return (
        this.$store.state.globals.settings.integrations.order_gifts_count <= this.$store.state.cart.selectedGifts.length
      )
    },
    remainder() {
      return this.gift.price_from - this.$store.state.cart.cartData.prices.totalWithTax
    },
  },
  methods: {
    addToCart() {
      this.startLoading()
      this.$store.commit('cart/ADD_GIFT', this.gift)
      this.$store.dispatch('cart/SET_GIFT_PRICES')
      notifications.success(this.$t('Gift.notifications.added'))
      this.stopLoading()
    },
    click() {
      if (this.isSelectable && !this.isSelected && !this.reachedMaxCountOfGifts) {
        this.addToCart()
      } else if (this.isSelectable && this.isSelected) {
        this.removeFromCart()
      }
    },
    removeFromCart() {
      this.$store.commit('cart/REMOVE_GIFT', this.gift)
      this.$store.dispatch('cart/SET_GIFT_PRICES')
      notifications.success(this.$t('Gift.notifications.removed'))
    },
  },
  watch: {
    isSelectable(newValue) {
      if (!newValue) {
        this.removeFromCart()
      }
    },
  },
}
